import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { USER_PORTAL_INVITE } from 'src/api';
import axios from 'src/axios';
import { FormInput } from 'src/components/molecules';
import { SpinnerButton } from 'src/components/molecules/SpinnerButton';
import { FormInputVariant, FormState } from 'src/types';
import {
  ACCOUNT_ACTIVATION_SOURCE,
  REPORTING_ACCOUNT_ACTIVATION_STEP,
  trackAccountActivation,
} from 'src/utils/analytics/track/reporting';
import { isEmail } from 'validator';
import { ReportingActivateSuccess } from '../ReportingActivateSuccess/ReportingActivateSuccess';
import { LoginContainer } from '../ReportingLoginContainer/ReportingLoginContainer';
import {
  ButtonContainer,
  Description,
  FormContainer,
  Header,
} from './ReportingActive.styles';

interface FormValues {
  email: string;
}

export const ReportingActivate = () => {
  const { t } = useTranslation();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const onSubmit = async (data: FormValues) => {
    await axios
      .post(USER_PORTAL_INVITE, {
        username: data.email,
      })
      .finally(() => setShowSuccess(true));

    trackAccountActivation({
      step_description: REPORTING_ACCOUNT_ACTIVATION_STEP.SEND_EMAIL,
      source: ACCOUNT_ACTIVATION_SOURCE.USER_PORTAL,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useForm<FormValues>({
    mode: 'onChange',
  });

  return (
    <>
      {!showSuccess ? (
        <LoginContainer>
          <FormContainer onSubmit={handleSubmit(onSubmit)}>
            <Header>{t('reporting.ReportingActivate.header')}</Header>
            <Description>
              {t('reporting.ReportingActivate.description')}
            </Description>
            <FormInput
              variant={FormInputVariant.INPUT}
              data-testid="activate-email-input"
              state={FormState.DEFAULT}
              label={t('reporting.ReportingActivate.emailInput')}
              placeholder={t('reporting.ReportingActivate.emailInput')}
              type="text"
              {...register('email', {
                required: true,
                validate: (value) => isEmail(value),
              })}
            />
            <ButtonContainer>
              <SpinnerButton
                variant="primary"
                size="medium"
                type="submit"
                width="100%"
                data-testid="activate-account-cta"
                disabled={!isDirty || !isValid}
                loading={false}
              >
                {t('reporting.ReportingActivate.buttonText')}
              </SpinnerButton>
            </ButtonContainer>
          </FormContainer>
        </LoginContainer>
      ) : (
        <ReportingActivateSuccess />
      )}
    </>
  );
};
